import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components/UI/Link/Link';
import { Button } from 'components/UI/Button/Button';
import { BookingModal } from 'components/BookingModal/BookingModal';
import './EventTileActions.scss';

export const EventTileActions = (props) => {
  const [open, setOpen] = useState(false);
  const openModalHandler = () => setOpen(true);
  const closeModalHandler = () => setOpen(false);

  const {
    infoUrl,
    bookNowVisible,
    bookNowText,
    bookNowUrl = 'Book tickets',
    bookNowTarget = '',
    eventMetaData,
  } = props;

  const isBookingModalButton = bookNowTarget === '_self';

  const externalBookingButton = (
    <Link href={bookNowUrl} target={bookNowTarget} buttonLink darkButton variant="secondary">
      {bookNowText}
    </Link>
  );

  const bookingModalButton = (
    <Button extendClass="btn-small" variant="primary" onClick={openModalHandler}>
      {bookNowText}
    </Button>
  );

  return (
    <div className="event-tile__actions">
      {open && (
        <BookingModal modalIsOpen={open} closeModalHandler={closeModalHandler} {...eventMetaData} />
      )}
      {bookNowVisible && (isBookingModalButton ? bookingModalButton : externalBookingButton)}
      <Link href={infoUrl} buttonLink>
        More info
      </Link>
    </div>
  );
};

EventTileActions.propTypes = {
  infoUrl: PropTypes.string.isRequired,
  bookNowVisible: PropTypes.bool,
  bookNowText: PropTypes.string,
  bookNowUrl: PropTypes.string,
  bookNowTarget: PropTypes.string,
  eventMetaData: PropTypes.object,
};
